export default "__VITE_ASSET__Cr7ZT7cq__"